import type { Animal } from './Animal.model';
import { type FeatureFlagType } from '@/model/FeatureFlag.model';
import type { Team } from './Team.model';
import type { MainUser } from './User.model';

export type StudyState = 'in_progress' | 'awaiting_approval' | 'rejected' | 'cancelled';

interface StudyPages {
  overview: boolean;
  animals: boolean;
  cages: boolean;
  graphs: boolean;
  workflow: boolean;
  treatmentGroups: boolean;
  attachments: boolean;
  samples: boolean;
  observations: boolean;
  doses: boolean;
  import: boolean;
  export: boolean;
  benchlingSync: boolean;
  settings: boolean;
  dataTables: boolean;
}

export const STUDY_CAGES_VIEW = {
  CARD: 'card',
  LIST: 'list',
} as const;

export type StudyCagesView = (typeof STUDY_CAGES_VIEW)[keyof typeof STUDY_CAGES_VIEW];

export const DEFAULT_STUDY_CAGES_VIEW: StudyCagesView = STUDY_CAGES_VIEW.CARD;

export interface State {
  ui: {
    settings: {
      sidebar: {
        collapsed: boolean;
      };
      /** Study Cages page layout preference. Defaults to card (legacy view). */
      studyCagesView?: StudyCagesView;
      studyState: {
        reviewState: StudyState;
        pageStates: StudyPages;
      };
      tables: {
        animals: {
          columns: Record<string, boolean>;
        };
        links: {
          columns: Record<string, boolean>;
        };
        samples: {
          columns: Record<string, boolean>;
        };
        studySamples: {
          columns: Record<string, boolean>;
        };
        treatments: {
          columns: Record<string, boolean>;
        };
        studycodes: {
          columns: Record<string, boolean>;
        };
        randomization: {
          columns: Record<string, boolean>;
        };
      };
    };
    currentStudyDetails: {
      id: string;
      name: string;
      code: string;
    };
  };
  team: {
    team: Team;
    features: Partial<Record<FeatureFlagType, boolean>>;
  };
  subjects: {
    selectedSubjects: Array<Animal>;
  };
  user: {
    currentUser: MainUser;
    timezones: Array<string>;
  };
}
